export enum KeyInInformationStep {
  NextOfKinDetails = 0,
  ServiceRecipientDetails = 1
}

// The BE persists client_link.relationship as free text (no fixed value set) — this list is
// owned entirely by the FE.
export enum RelationshipToClient {
  Brother = 'Brother',
  Child = 'Child',
  DaughterInLaw = 'Daughter-in-law',
  Daughter = 'Daughter',
  Neighbour = 'Neighbour',
  Other = 'Others',
  Parent = 'Parent',
  Patient = 'Patient',
  Sibling = 'Sibling',
  Sister = 'Sister',
  SonInLaw = 'Son-in-law',
  Son = 'Son',
  Spouse = 'Spouse'
}

// Despite the name, this covers both the NOK flow's service-recipient (B3 client) details AND the
// SELF flow's own personal details (SelfDetailsForm / ConfirmDetailsMySelf) - same field set either way.
export interface ServiceRecipientFormValues {
  fullName: string;
  dateOfBirth: string;
  gender: string;
  nric: string;
  email: string;
  homeNo?: string;
  mobileNo: string;
  maritalStatus?: string;
  residentialStatus?: string;
  nationality?: string;
  languagesSpoken: string[];
  otherLanguage?: string;
  isNtucMember: boolean;
  ntucMemberNo?: string;
}

export interface NextOfKinFormValues {
  name: string;
  email: string;
  homeNo?: string;
  mobileNo: string;
  relationshipToClient: string;
  relationshipOthers?: string;
  isDecisionMaker: boolean;
}
